import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		fill: "#fff",
		cx: 9,
		cy: 9,
		r: 8.5,
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		r: 6,
		fill: "currentColor"
	})]
});
export default SvgRadioChecked;
